export default __webpack_public_path__ + "static/media/small.70755a32.jpg";